// getters
const papeleriaProductsSubCategories = state => state.papeleriaProductsSubCategories

export default {
  papeleriaProductsSubCategories
}



// WEBPACK FOOTER //
// ./src/store/modules/papeleria/products/subcategories/getters.js